//https://www.bezkoder.com/react-login-example-jwt-hooks/
import { IsNullOrEmpty } from "../services/CustomService";

export async function switchAccount(childId) {

    let model = {
        ChildId: childId
    };

    const response = await fetch('/api/authenticate/switch', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + getToken(),
        },

        body: JSON.stringify(model)
    });
    const data = await response.json();
    if (data) {
        localStorage.removeItem("user");
        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.removeItem("holidaysMode");
        localStorage.setItem("holidaysMode", JSON.stringify(data.holidaysMode))

    }
    return data;
}

export async function redirectToLogin() {
    localStorage.removeItem("user");
    localStorage.removeItem("holidaysMode");
    window.location.replace('/login');
}
export async function login(params) {
    let source = {
        Email: params.email,
        Password: params.password
    };

    const response = await fetch('/api/authenticate/login', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(source)
    });
    const raw = await response.text();
    const data = raw ? JSON.parse(raw) : {};
    data.status = response.status;

    if (data?.user) {
        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.setItem("holidaysMode", JSON.stringify(data.holidaysMode))
    } else {
        localStorage.removeItem("user");
        localStorage.removeItem("holidaysMode");
    }
    return data;
}
export async function resetPassword(params) {
    let source = {
        Email: params.email
    };

    const response = await fetch('/api/authenticate/reset-password', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(source)
    });
    const data = await response.json();

    return data;
}

export async function updatePassword(params) {
    let source = {
        Email: params.email,
        Password: params.password,
        Token: params.token
    };

    const response = await fetch('/api/authenticate/update-password', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(source)
    });
    const data = await response.json();

    return data;
}


export async function logout() {

    const response = await fetch('/api/authenticate/logout', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        },
    });

    localStorage.removeItem("user");
    localStorage.removeItem("holidaysMode");
}
export function isConnected() {
    let u = localStorage.getItem("user");
    if (IsNullOrEmpty(u) === false) {
        let user = JSON.parse(u);
        if (user) {
            return true;
        }
    }
   
    return false;
}
export function getCurrentUser() {

    let u = localStorage.getItem("user");
    if (IsNullOrEmpty(u) === false) {
        let user = JSON.parse(u);
        if (user) {
            return user;
        }
    } 

    window.location.replace('/login');
}


export function getToken() {

    const user = getCurrentUser();
    let token = '';
    if (user) {
        token = user.token;
    }
    return token;
}

// Lecture du user sans redirection (contrairement à getCurrentUser).
export function getStoredUser() {
    const u = localStorage.getItem("user");
    if (IsNullOrEmpty(u)) return null;
    try { return JSON.parse(u); } catch (e) { return null; }
}

// Rafraîchit le token d'accès via le refresh token (mono-vol : une seule requête
// en parallèle, les appels concurrents attendent la même promesse). Renvoie true si OK.
let refreshPromise = null;
export function tryRefreshToken() {
    if (refreshPromise) return refreshPromise;
    const user = getStoredUser();
    if (!user || !user.token || !user.refreshToken) return Promise.resolve(false);

    refreshPromise = fetch('/api/authenticate/refresh-token', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({ AccessToken: user.token, RefreshToken: user.refreshToken })
    })
        .then(async (response) => {
            if (!response.ok) return false;
            const data = await response.json().catch(() => null);
            if (!data || !data.accessToken) return false;
            const current = getStoredUser() || user;
            localStorage.setItem("user", JSON.stringify({
                ...current, token: data.accessToken, refreshToken: data.refreshToken
            }));
            return true;
        })
        .catch(() => false)
        .finally(() => { refreshPromise = null; });

    return refreshPromise;
}
